import Image from "next/image";
import { useTranslation } from "react-i18next";
import accesibility_new from "@/assets/images/icons/accessibility_new.svg";
import accesible from "@/assets/images/icons/accessible.svg";
import duration from "@/assets/images/icons/duration.svg";
import language from "@/assets/images/icons/language.svg";
import location_on from "@/assets/images/icons/location_on.svg";
import pets from "@/assets/images/icons/pets.svg";
import { CustomDiv, InlineDiv } from "@/common/divs";
import { AlmostBoldText, LightText, LightTextSpan } from "@/common/texts";
import { ActivityAddressVm, ActivityDetailVm } from "@/model";
import { StaticInfoType } from "@/types/components";
import { PRIMARY_BRAND_VARIANT_COLOR } from "@/utils/constants";

const DetailedContainer: React.FC<{
  location: ActivityAddressVm;
  info: StaticInfoType;
  more_info: ActivityDetailVm | undefined;
}> = ({ location, info, more_info }) => {
  const { t } = useTranslation();
  return (
    <CustomDiv
      width="100%"
      paddingX="16px"
      marginY="16px"
      paddingY="24px"
      background={PRIMARY_BRAND_VARIANT_COLOR}
      className="detailed-container"
    >
      <InlineDiv>
        <Image
          src={location_on}
          alt="location"
          width="24"
          height="24"
          style={{ marginRight: "8px", width: "24px", height: "24px" }}
        />
        <AlmostBoldText
          style={{ display: "flex", gap: "3px", alignContent: "center" }}
        >
          {t("activity.details.location")}:{" "}
          <LightTextSpan style={{ marginTop: "1px" }}>
            {location.formattedAddress}
          </LightTextSpan>{" "}
        </AlmostBoldText>
      </InlineDiv>

      {
        //TODO
      }
      {info.duration && (
        <InlineDiv>
          <Image
            src={duration}
            alt="location"
            width="24"
            height="24"
            style={{ marginRight: "8px" }}
          />
          <AlmostBoldText style={{ display: "flex", gap: "3px" }}>
            {t("activity.map.duration")}:{" "}
            <LightText style={{ marginTop: "1px" }}>{info.duration}</LightText>{" "}
          </AlmostBoldText>
        </InlineDiv>
      )}
      {more_info?.language && (
        <InlineDiv>
          <Image
            src={language}
            alt="language"
            width="24"
            height="24"
            style={{ marginRight: "8px", width: "24px", height: "24px" }}
          />
          <AlmostBoldText
            style={{ display: "flex", gap: "3px", alignContent: "center" }}
          >
            {t("language_screen.lanaguages_text")}:{" "}
            <LightText style={{ marginTop: "1px" }}>
              {more_info?.language.map((language) => language.name).join(", ")}
            </LightText>{" "}
          </AlmostBoldText>
        </InlineDiv>
      )}
      {more_info?.tags?.some(
        (tag) => tag.name === "Personas con movilidad reducida",
      ) && (
        <InlineDiv>
          <Image
            src={accesible}
            alt="location"
            width="24"
            height="24"
            style={{ marginRight: "8px", width: "24px", height: "24px" }}
          />
          <AlmostBoldText
            style={{ display: "flex", gap: "3px", alignContent: "center" }}
          >
            {t("activities.filter.accessibility")}:{" "}
            <LightText style={{ marginTop: "1px" }}>
              {t("tags.personas_con_movilidad_reducida")}
            </LightText>{" "}
          </AlmostBoldText>
        </InlineDiv>
      )}
      <InlineDiv>
        <Image
          src={accesibility_new}
          alt="accesibility"
          width="24"
          height="24"
          style={{ marginRight: "8px", width: "24px", height: "24px" }}
        />
        <AlmostBoldText
          style={{ display: "flex", gap: "3px", alignContent: "center" }}
        >
          {t("activity.public")}:{" "}
          <LightText style={{ marginTop: "1px" }}>
            {info.public.join(", ")}
          </LightText>{" "}
        </AlmostBoldText>
      </InlineDiv>
      {info.pet_friendly && (
        <InlineDiv>
          <Image
            src={pets}
            alt="pets"
            width="24"
            height="24"
            style={{ marginRight: "8px", width: "24px", height: "24px" }}
          />
          <AlmostBoldText
            style={{ display: "flex", gap: "3px", alignContent: "center" }}
          >
            {t("tags.pet_friendly")}:{" "}
            <LightText style={{ marginTop: "1px" }}>
              {info.pet_friendly ? t("activity.yes") : t("activity.no")}
            </LightText>{" "}
          </AlmostBoldText>
        </InlineDiv>
      )}
    </CustomDiv>
  );
};

export default DetailedContainer;
